export default {
    en: "English",
    zh: "简体中文",
    zh_tw: "繁體中文",
    es: "Castellano",
    fr: "français",
    fr_ca: "français (CA-FR)",
    de: "Deutsch",
    it: "Italiano",
    ru:"Pусский",
    ko:"한국어"
}